import { useAmazonHoverTriangle } from "@faire/retailer-visitor-shared/components/Header/desktop/NavigationLinksBar/__internal__/AmazonHoverTriangle/__internal__/useAmazonHoverTriangle";
import { useCallback } from "react";
export var AmazonHoverTriangleTrackerDropdownDirection;
(function(AmazonHoverTriangleTrackerDropdownDirection) {
    AmazonHoverTriangleTrackerDropdownDirection[AmazonHoverTriangleTrackerDropdownDirection["TOP"] = 0] = "TOP";
    AmazonHoverTriangleTrackerDropdownDirection[AmazonHoverTriangleTrackerDropdownDirection["BOTTOM"] = 1] = "BOTTOM";
    AmazonHoverTriangleTrackerDropdownDirection[AmazonHoverTriangleTrackerDropdownDirection["LEFT"] = 2] = "LEFT";
    AmazonHoverTriangleTrackerDropdownDirection[AmazonHoverTriangleTrackerDropdownDirection["RIGHT"] = 3] = "RIGHT";
})(AmazonHoverTriangleTrackerDropdownDirection || (AmazonHoverTriangleTrackerDropdownDirection = {}));
export var useAmazonHoverTriangleTracker = function(ref, onMouseMoveOutsideTriangle, dropdownDirection) {
    var _useAmazonHoverTriangle = useAmazonHoverTriangle(), points = _useAmazonHoverTriangle.points, setTriangle = _useAmazonHoverTriangle.setTriangle, isPointInsideTriangle = _useAmazonHoverTriangle.isPointInsideTriangle;
    var onMouseMove = useCallback(function(event) {
        var _ref_current;
        var point = {
            x: event.clientX,
            y: event.clientY
        };
        if (points && !isPointInsideTriangle(point)) {
            onMouseMoveOutsideTriangle();
        }
        var contentBound = (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.getBoundingClientRect();
        if (contentBound) {
            var left = contentBound.left, right = contentBound.right, top = contentBound.top, bottom = contentBound.bottom;
            var pointA = {
                x: dropdownDirection === AmazonHoverTriangleTrackerDropdownDirection.LEFT ? right : left,
                y: dropdownDirection === AmazonHoverTriangleTrackerDropdownDirection.TOP ? bottom : top
            };
            var pointB = {
                x: dropdownDirection === AmazonHoverTriangleTrackerDropdownDirection.RIGHT ? left : right,
                y: dropdownDirection === AmazonHoverTriangleTrackerDropdownDirection.BOTTOM ? top : bottom
            };
            setTriangle(point, pointA, pointB);
        }
    }, [
        dropdownDirection,
        isPointInsideTriangle,
        onMouseMoveOutsideTriangle,
        points,
        ref,
        setTriangle
    ]);
    return {
        onMouseMove: onMouseMove
    };
};
